import 'vite/modulepreload-polyfill';
import { PUBLIC_PATH } from './config';
import svgxhr from './src/js/helpers/svgxhr';
import './src/js/index';

svgxhr({ filename: `/${PUBLIC_PATH}images/svgsheet.svg` });
